import React, {useMemo, useState} from 'react';
import {Stack, useMediaQuery, useTheme} from '@mui/material';
import {useSnackbar} from 'notistack';
import api from '../util/api.js';
import {useBusyCallback} from '../util/react_hooks.js';
import SCButton from './SCButton.js';
import SCTextField from './SCTextField.js';
import ConsentCheckbox from './ConsentCheckbox.js';

const ContactForm = ()=>{
    let [name, setName] = useState('');
    let [email, setEmail] = useState('');
    let [message, setMessage] = useState('');
    let [constent, setConsent] = useState(false);
    let [validationErrors, setValidationErrors] = useState({});
    let {enqueueSnackbar} = useSnackbar();
    let theme = useTheme();
    let md = useMediaQuery(theme.breakpoints.down('md'));
    let sm = useMediaQuery(theme.breakpoints.down('sm'));
    let width = useMemo(()=>{
        if (sm) return '200px';
        if (md) return '400px';
        return '500px';
    }, [sm, md]);
    let [submit, submitting] = useBusyCallback(async ()=>{
        setValidationErrors({});
        try {
            await api.contact({name, email, message});
            enqueueSnackbar('ההודעה נשלחה', {variant: 'success'});
        } catch (e) {
            if (e.code!='validation_error')
                return void enqueueSnackbar('אירעה שגיאה, נסו שוב מאוחר יותר', {variant: 'error'});
            setValidationErrors(e.extra.reduce((acc, c)=>({...acc, [c.path[0]]: c.message}), {}));
        }
    }, [name, email, message, enqueueSnackbar]);
    return <Stack direction="column" gap={3} justifyContent="center"
      width={width}>
      <SCTextField required label="שם" variant="outlined" value={name} onChange={setName}
        error={!!validationErrors.name} helperText={validationErrors.name}/>
      <SCTextField required label="מייל" variant="outlined" value={email} onChange={setEmail}
        error={!!validationErrors.email} helperText={validationErrors.email}/>
      <SCTextField required label="הודעה" multiline rows={4} variant="outlined" value={message}
        onChange={setMessage} error={!!validationErrors.message} helperText={validationErrors.message}
        placeholder="ספר.י לי איך אוכל לעזור"/>
      <ConsentCheckbox value={constent} onChange={setConsent}/>
      <SCButton text="שלח.י" variant="outlined" onClick={submit} loading={submitting}
        size="large" disabled={!constent}/>
    </Stack>;
};

export default ContactForm;
